module.exports = __webpack_public_path__ + "img/Check.f236c85e.svg";